import script from "./copy-check-list-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./copy-check-list-modal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__